module.exports = __webpack_public_path__ + "media/logos/cuk_logo_white-e2ec0f85.png";